export default "__VITE_ASSET__af834216__"